import { useEditorState } from '@tiptap/react';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

const TableToolbar = ({ editor }) => {
    const editorState = useEditorState({
        editor,
        selector: (ctx) => ({
            isTable: ctx.editor.isActive('table') ?? false,
            isTableHeader: ctx.editor.isActive('tableHeader') ?? false,
            canMergeCells: ctx.editor.can().chain().mergeCells().run() ?? false,
            canSplitCell: ctx.editor.can().chain().splitCell().run() ?? false,
        }),
    });

    if (!editorState.isTable || !editor.isEditable) {
        return null;
    }

    return (
        <div>
            <div className="table-toolbar">
                <Button size="xs" onClick={() => editor.chain().focus().addColumnBefore().run()}>
                    Add column before
                </Button>
                <Button size="xs" onClick={() => editor.chain().focus().addColumnAfter().run()}>
                    Add column after
                </Button>
                <Button size="xs" onClick={() => editor.chain().focus().deleteColumn().run()}>
                    Delete column
                </Button>
                <Button
                    size="xs"
                    onClick={() => editor.chain().focus().addRowBefore().run()}
                    disabled={editorState.isTableHeader}
                >
                    Add row before
                </Button>
                <Button size="xs" onClick={() => editor.chain().focus().addRowAfter().run()}>
                    Add row after
                </Button>
                <Button
                    size="xs"
                    onClick={() => editor.chain().focus().deleteRow().run()}
                    disabled={editorState.isTableHeader}
                >
                    Delete row
                </Button>
                <Button
                    size="xs"
                    onClick={() => editor.chain().focus().deleteTable().run()}
                    style={{ color: 'var(--brandDanger)' }}
                >
                    Delete table
                </Button>
                <Button
                    size="xs"
                    onClick={() => editor.chain().focus().mergeCells().run()}
                    disabled={!editorState.canMergeCells}
                >
                    Merge cells
                </Button>
                <Button
                    size="xs"
                    onClick={() => editor.chain().focus().splitCell().run()}
                    disabled={!editorState.canSplitCell}
                >
                    Split cell
                </Button>
                <Button size="xs" onClick={() => editor.chain().focus().toggleHeaderRow().run()}>
                    Toggle header row
                </Button>
            </div>
        </div>
    );
};

TableToolbar.propTypes = {
    editor: PropTypes.shape({
        isActive: PropTypes.func,
        chain: PropTypes.func,
        isEditable: PropTypes.bool,
    }).isRequired,
};

export default TableToolbar;
